const colors = {
  orange: "#FF8450",
  grey: "#E2E2E2",
  lightGrey: "#F6F6F6",
  black: "#5B5555",
  white: "#FFFFFF",
};

const theme = {
  colors,
};

export default theme;
